import {
  ADMIN_ROLE,
  GUEST_ROLE,
  INSTRUCTOR_ROLE,
  STUDENT_ROLE,
} from "@constants";
import { useSelector } from "react-redux";
import { difference, intersection } from "lodash";

export const useAccessControl = (targetRoles = [], exceptRoles = []) => {
  const roles = [ADMIN_ROLE, INSTRUCTOR_ROLE, STUDENT_ROLE, GUEST_ROLE];
  const { login } = useSelector((state) => state.auth);
  const { isAuth, role } = login;

  const permissionList = intersection(
    difference(roles, exceptRoles),
    targetRoles.length ? targetRoles : roles
  );
  const permission = permissionList.includes(role);

  return { isAuth, role, permission };
};
